// extracted by mini-css-extract-plugin
export var columns = "algolia-module--columns--b5386";
export var container = "algolia-module--container--89620";